import React from 'react';
import { classList } from '../../../utils/string.ts';

export type IconProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
  name: string;
  className?: string;
};

export const Icon: React.FunctionComponent<IconProps> = props => {
  const { name, className, ...htmlAttributes } = props;
  return <i {...htmlAttributes} className={classList(`ic-${props.name}`, className)} />;
};
